import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import { DashboardSearchProps, Sentiments, SentimentsOnDate } from "../../../../domain/repositories/dashboard.repository";
import DateDto from "../../../dto/date.dto";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import SentimentsOnDateDto from "../../../dto/sentiment_on_date.dto";
import DatesUtils from "../../../../presentation/utils/dates_utils";

const getDayToDayApiImpl = async (_: DashboardSearchProps): Promise<Either<ErrorEntity, SentimentsOnDate[]>> => {
    try {
        let relativeUrl = "/stats/call-sentiments?";
        const { startDate, endDate, aiAgentId, callTypeId, humanAgentId, operationId }: { startDate: Date, endDate: Date, operationId?: string, humanAgentId?: string, aiAgentId?: string, callTypeId?: string, } = _;
        if (startDate) relativeUrl += `start_date=${DateDto.toServer(startDate)}&`
        if (endDate) relativeUrl += `end_date=${DateDto.toServer(endDate)}&`
        if (aiAgentId) relativeUrl += `agent_id=${aiAgentId}&`
        if (callTypeId) relativeUrl += `call_type=${callTypeId}&`
        if (humanAgentId) relativeUrl += `human_agent_id=${humanAgentId}&`
        if (operationId) relativeUrl += `operation_id=${operationId}&`
        relativeUrl = relativeUrl.slice(0, -1); // remove the last '&'
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl, {
            contentType: 'application/json',
        });
        const parsed = response.map((item: any) => SentimentsOnDateDto.fromJson(item));

        const clean: Sentiments = {
            negative: 0,
            neutral: 0,
            positive: 0,
        }
        //run day by day and add clean where needed
        const arrayOfDates = Array.from({ length: ((endDate.getTime() + (1000 * 60 * 60 * 24)) - startDate.getTime()) / (1000 * 60 * 60 * 24) + 1 }, (_, i) => new Date(startDate.getTime() + (i * 1000 * 60 * 60 * 24)));
        const result = arrayOfDates.map((date: Date) => {
            const found = parsed.find((item: SentimentsOnDate) => DatesUtils.isSameDate(item.date, date));
            if (found) {
                return found;
            }
            return {
                date,
                sentiments: clean,
            }
        });
        if (result.length == 1) {
            result.push(result[0]);
        }
        console.log("result", {result, parsed});
        return right(result);
    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default getDayToDayApiImpl;